// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__1tWTW","content":"styles_content__nV+FY","actions":"styles_actions__zYXbT","alert":"styles_alert__eKSWD"};